import { clsx } from 'clsx';

import type { PropsWithChildren, ReactNode } from 'react';

import styles from './InfoMessage.module.css';

import { Icon } from 'components/Icon';

export interface InfoMessageProps {
  /** The message to show. */
  message: string | ReactNode;
  /** `true` if the info message should be wrapped in a container; otherwise, `false`. */
  hasOwnContainer?: boolean;
}

/** Represents a component to show an info message. */
export const InfoMessage = ({ message, hasOwnContainer = false }: PropsWithChildren<InfoMessageProps>) => (
  <div
    className={clsx(styles['info-message'], {
      [styles['info-message__container']]: hasOwnContainer,
    })}
  >
    <Icon name="InformationCircleFillMini" className={styles['info-message__icon']} />
    {message}
  </div>
);
